import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  id: "attach-icon",
  role: "img",
  viewBox: "0 0 24 24"
}

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, _cache[0] || (_cache[0] = [
    _createElementVNode("path", { d: "M16.494 6.566a2.785 2.785 0 1 1 3.94 3.94l-5.88 5.879a2.785 2.785 0 1 1-3.939-3.94l.879-.879a.75.75 0 1 0-1.06-1.06l-.88.879a4.285 4.285 0 1 0 6.061 6.06l5.879-5.879a4.285 4.285 0 1 0-6.06-6.06.75.75 0 0 0 1.06 1.06Z" }, null, -1),
    _createElementVNode("path", { d: "M9.445 8.615a2.785 2.785 0 1 1 3.94 3.94l-.916.915a.75.75 0 1 0 1.061 1.06l.915-.915a4.285 4.285 0 1 0-6.06-6.06l-5.88 5.879a4.285 4.285 0 1 0 6.061 6.06.75.75 0 1 0-1.06-1.06 2.785 2.785 0 1 1-3.94-3.94l5.88-5.879Z" }, null, -1)
  ])))
}
export default { render: render }